<section class="ingest-upload-hub">
  <app-page-header
    title="Carga de documentos"
    subtitle="Elige un expediente y abre la ingesta: archivos sueltos, carpetas con estructura o ambos, con seguimiento por archivo."
    icon="Upload"
    [actions]="headerActions()"
    (actionClick)="onHeaderAction($event)"
  />

  @if (loading()) {
    <div class="loading-container">
      <lib-empty message="Cargando expedientes" description="Espere por favor..." />
    </div>
  } @else if (error()) {
    <app-vault-page-alert
      type="error"
      title="Error"
      [message]="error()"
      (closed)="error.set(null)"
    />
  } @else {
    @if (info()) {
      <app-vault-page-alert
        type="info"
        title="Aviso"
        [message]="info()"
        (closed)="info.set(null)"
      />
    }
    <app-grid-form preset="responsive" wrapperClass="ingest-upload-hub__grid">
      <app-grid-form-item [span]="'full'" class="ingest-field ingest-upload-hub__field">
        <app-field-label
          label="Expediente"
          [required]="true"
          tooltip="Selecciona el expediente donde se registrará la carga de documentos. Solo se listan expedientes activos; los inactivos no permiten ingesta."
        />
        <lib-select
          label=""
          placeholder="Selecciona un expediente"
          [options]="projectOptions()"
          [value]="selectedProjectId()"
          (valueChange)="onSelectedProjectIdChange($event)"
          [searchable]="true"
          [required]="true"
        />
      </app-grid-form-item>
    </app-grid-form>
  }
</section>
